import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../urunDiv.css';
import hamburgEr from '../../assets/menu/yemekler/hamburgerler/hamburg-er.jpeg';
import ciftKofteTekLezzet from '../../assets/menu/yemekler/hamburgerler/cift-kofte-tek-lezzet.png';





const Hamburgerler = () => {
  const [isPhone, setIsPhone] = useState(window.innerWidth < 768)
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsPhone(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const hamburgerler = [
    {
      id: 1,
      name: 'Hamburger',
      price: '₺619,90',
      image: hamburgEr
    },
    {
      id: 2,
      name: 'Çift Köfte Tek Lezzet',
      price: '₺749,90',
      image: ciftKofteTekLezzet
    }
  ];

  const handleHamburgerClick = (hamburger) => {
    if (hamburger.name === 'Hamburger') {
      navigate('/hamburgerler/hamburger');
    } else if (hamburger.name === 'Çift Köfte Tek Lezzet') {
      navigate('/hamburgerler/cift-kofte-tek-lezzet');
    }
  };

  return (
    isPhone ? (
      <div className="urun-container">
        <div className="container" style={{marginTop: '20px'}}>
          <h2 style={{marginTop: '0px', marginLeft: 'auto', fontWeight: '700' }}>Hamburgerler</h2>
        </div>
        <hr style={{color: '#D8D8D8'}} />
        <div className="urun-grid">
          {hamburgerler.map((hamburger) => (
            <div 
              key={hamburger.id} 
              className="urun-kart"
              onClick={() => handleHamburgerClick(hamburger)}
              style={{ cursor: 'pointer' }}
            >
              <div className="urun-bilgi">
                <h3 className="urun-ad">{hamburger.name}</h3>
                <div className="urun-fiyat">{hamburger.price}</div>
              </div>
              <div className="urun-resim">
                <img src={hamburger.image} alt={hamburger.name} style={{
                  width: '80px',
                  height: '80px',
                  objectFit: 'cover',
                  borderRadius: '100px',
                }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    ) : (
      <div className="urun-container">
        <div className="container" style={{marginTop: '20px'}}>
          <h2 style={{marginTop: '0px', marginLeft: 'auto', fontWeight: '700' }}>Hamburgerler</h2>
        </div>
        <hr style={{color: '#D8D8D8'}} />
        <div className="urun-grid-computer">
          {hamburgerler.map((hamburger) => (
            <div 
              key={hamburger.id} 
              className="urun-kart-computer"
              onClick={() => handleHamburgerClick(hamburger)}
              style={{ cursor: 'pointer' }}
            >
              <div className="urun-bilgi">
                <h3 className="urun-ad-computer">{hamburger.name}</h3>
                <div className="urun-fiyat-computer">{hamburger.price}</div>
              </div>
              <div className="urun-resim">
                <img src={hamburger.image} alt={hamburger.name} style={{
                  width: '100px',
                  height: '100px',
                  objectFit: 'cover',
                  borderRadius: '100px',
                }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  );
};

export default Hamburgerler;
